import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles(
  (theme: Theme) =>
    createStyles({
      root: {
        width: '100%',
      },
      content: {
        fontFamily: 'Nunito',
        fontWeight: 300,
        fontSize: '16px',
        textAlign: 'justify',
        letterSpacing: '0.44px',
        whiteSpace: 'pre-wrap',
      }
    }),
  {
    name: 'ConfirmModal',
  }
);

export const useFooterStyles = makeStyles(
  (theme: Theme) =>
    createStyles({
      leftContent: {
        display: 'flex',
        alignItems: 'flex-start',
        flexDirection: 'column',
        [theme.breakpoints.down('xs')]: {
          alignItems: 'stretch',
        }
      },
      rightContent: {
        display: 'flex',
        alignItems: 'flex-end',
        flexDirection: 'column',
        [theme.breakpoints.down('xs')]: {
          alignItems: 'stretch',
          paddingTop: '10px'
        }
      },
    }),
  {
    name: 'ConfirmModalFooter',
  }
);